













































































































































































































import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Component } from 'vue-property-decorator';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import moment from 'moment';
import { fetchMID } from './fetchMID';

@Component({
  components: {
    MantenedorGridSinCodigo,
  },
})
export default class MantenedorEndpoints extends ComponenteBase {
  funcionalidad: Funcionalidades = Funcionalidades.MantenedorEndpoints;
  accionesTotales: PermisoAccion[] = [];
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  search: string = '';

  gridApi: GridApi;
  gridOptions: GridOptions;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;
  showModalNew: boolean = false;
  plataformas: any = [
    { id: 1, nombre: 'Integración' },
    { id: 2, nombre: 'Track' },
  ];
  selected: any = {
    plataforma: 1,
    integrador: '',
    nombrelogico: '',
    motor: '',
    mandante: '',
    nombre_ws: '',
    endpoint: '',
    usuario: '',
    password: '',
    pathlog: '',
    pathinstalacion: '',
    canal: 'gpschile',
  };

  mounted() {
    this.getAllMotor();
  }

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Motor',
        field: 'motor',
        resizable: true,
        sortable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Integrador',
        field: 'integrador',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre Logico',
        field: 'nombrelogico',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre WebService',
        field: 'nombre_ws',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Mandante',
        field: 'mandante',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Endpoint',
        field: 'endpoint',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Usuario',
        field: 'usuario',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Password',
        field: 'password',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Ruta Física',
        field: 'pathinstalacion',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Ruta Log',
        field: 'pathlog',
        resizable: true,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  async getAllMotor() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID({ canal: 'gpschile' }, 'marcaBlanca/getMotor')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          console.log(data.data);
          self.gridApi.setRowData(data.data.data);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  closeModal() {
    this.showModalNew = false;
    this.cleanSelected();
    this.$validator.reset();
  }

  async grabar() {
    var valid = await this.$validator.validateAll();
    if (!valid) {
      console.log('return');
      return;
    }
    this.selected.canal = 'gpschile';
    console.log(this.selected);
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(self.selected, 'marcaBlanca/postMotor')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          console.log(data.data);
          self.$snotify.success(data.data.data, { timeout: 3000 });
          this.showModalNew = false;
          this.cleanSelected();

          this.$validator.reset();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.getAllMotor();
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
  }

  cleanSelected() {
    this.selected = {
      plataforma: 1,
      integrador: '',
      nombrelogico: '',
      motor: '',
      mandante: '',
      nombre_ws: '',
      endpoint: '',
      usuario: '',
      password: '',
      pathlog: '',
      pathinstalacion: '',
      canal: 'gpschile',
    };
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onFilterTextBoxChanged() {
    if (this.search === null) this.search = '';
    this.gridApi.setQuickFilter(this.search.length > 1 ? this.search : '');
  }

  onSelectionChanged(params: any) {}

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
}
